import { useSelector } from 'react-redux'

import ReportsModerator from './Reports.moderator.view'

const Reports = () => {
    const isModerator = useSelector((state) => state.profile.profile.isModerator)

    return isModerator ? <ReportsModerator /> : null
}

export default Reports
